import { EntityTypes, MergedEntityTypes } from '../../fr-entity-panels/types';

export const CARD_BUTTON_SECTION_WIDTH = '90px';

export const PERSON_ENTITY_TYPES = [
    EntityTypes.REPORTING_PARTIES,
    EntityTypes.INVOLVED_PERSONS,
    MergedEntityTypes.REPORTING_PARTIES,
    MergedEntityTypes.INVOLVED_PERSONS,
];

export const TOW_VEHICLES_ENTITY_TYPES = [EntityTypes.TOW_VEHICLES, MergedEntityTypes.TOW_VEHICLES];

export const PROPERTY_ENTITY_TYPES = [
    EntityTypes.FIREARMS,
    MergedEntityTypes.FIREARMS,
    EntityTypes.DRUGS,
    MergedEntityTypes.DRUGS,
    EntityTypes.OTHER_ITEMS,
    MergedEntityTypes.OTHER_ITEMS,
];
